import React from 'react';
import POSButton from 'PointOfSale/modules/common/component/Button';
import PropTypes from 'prop-types';

const ContinueButton = props => {
  const {
    currentSelectedSession,
    currentSession,
    selectedPageIndex,
    handleBack,
    handleStartServing,
  } = props;
  const isDisabled = () => {
    let disabled = false;
    if (selectedPageIndex === 2 && !currentSession.quickServeSelectedItem) {
      disabled = true;
    }

    if (currentSession.quickServeSelectedItem === null) {
      disabled = false;
    }

    return disabled;
  };
  return currentSelectedSession ? (
    <POSButton
      key="btnEnable"
      fluid={true}
      label={selectedPageIndex === 1 ? 'Continue' : 'Start serving'}
      selected={true}
      style={{ marginLeft: 0 }}
      clickHandler={
        selectedPageIndex === 1 ? handleBack.bind(this, 2) : handleStartServing
      }
      disabled={isDisabled()}
    />
  ) : (
    <POSButton
      key="btnDisable"
      fluid
      label={'Continue'}
      disabled={true}
      style={{ marginLeft: 0 }}
    />
  );
};

ContinueButton.propTypes = {
  currentSelectedSession: PropTypes.string,
  currentSession: PropTypes.object,
  selectedPageIndex: PropTypes.number,
  handleBack: PropTypes.func,
  handleStartServing: PropTypes.func,
};
export default ContinueButton;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/component/ContinueButton.js